import * as _ from 'lodash';
import { BaseObject } from './BaseObject';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 * @typedef { import('./Meeting').Meeting } Meeting
*/

export class Payment extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);
        }
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.WageType = ctx.getWageType(this.WageTypeId);
        this.PaymentRound = ctx.getPaymentRound(this.PaymentRoundId);
    }

    toJSON() {
        var ret = super.toJSON();
        ret.WageTypeId = BaseObject.withRelated(ret, "WageType");
        ret.PaymentRoundId = BaseObject.withRelated(ret, "PaymentRound");
        return ret;
    }

    clone() {
        var src = _.clone(this);
        src.WageType = null;
        src.PaymentRound = null;

        var ret = _.cloneDeep(src);
        ret.WageType = this.WageType;
        ret.PaymentRound = this.PaymentRound;
        return ret;
    }
}
